var waiterDom = require('./waiter.html');
var modalDom = require('./modal.html');

class YouSignHandler {
  constructor(target, promoter_slug, reservation_id) {
    this.target = target;
    this.promoter_slug = promoter_slug;
    this.reservation_id = reservation_id;
  }

  startWaiting() {
    this.target.append($( waiterDom ));
    // this.refreshStatus();
    this.refreshStatusInterval = setInterval(() => { this.refreshStatus() }, 1000);
  }

  refreshStatus() {
    $.ajax({
      method: 'GET',
      url: `/api/${this.promoter_slug}/reservations/${this.reservation_id}`
    })
    .done((data) => {
      var resaData = data.reservation;
      if (resaData['status'] === 'cancelled') {
        this.showSignatureModal(resaData.yousign_iframe_url);
        clearInterval(this.refreshStatusInterval);
        this.showBackFooter();
      }
      else if (!_.isNil(resaData['signed_at'])) {
        this.showSignatureModal(resaData.yousign_iframe_url);
        clearInterval(this.refreshStatusInterval);
        this.showNextStepFooter();
      }
      else if (!_.isNil(resaData['yousign_iframe_url'])) {
        this.showSignatureModal(resaData.yousign_iframe_url);
      }
    })
    .fail((e) => {
      console.log('error', e);
    });
  }

  showSignatureModal(iframeUrl) {
    if (!_.isNil(this.modal))
    {
      return;
    }

    this.target.empty();
    this.modal = $( modalDom );
    this.modal.find('#yousignIframe').attr('src', iframeUrl);
    $( 'body' ).append(this.modal);
    $( '#yousignModal' ).modal('show');
  }

  showNextStepFooter() {
    this.modal.find('#yousignModalFooter').show();
    this.modal.find('#nextStepButton').attr('href', this.reservationPath);
  }

  showBackFooter() {
    this.modal.find('#yousignModalFooter').show();
    this.modal.find('#yousignModalFooter').prepend('<h6>La signature a été annulée.</h6>');

    this.modal.find('#nextStepButton').attr('href', this.reservationPath);
    this.modal.find('#nextStepButton').text('Retour');
  }

  setReservationPath(value) {
    this.reservationPath = value;
  }
}

var buildYouSignHandler = function (options) {
  var settings = $.extend({
  }, options );
  var builder = new YouSignHandler($(this), $(this).data('promoter-slug'), $(this).data('reservation-id'));
  builder.setReservationPath($(this).data('reservation-path'));
  builder.startWaiting();

  return builder;
};

export default buildYouSignHandler;
